import { createFileRoute } from "@tanstack/react-router";
import { resetAllStorage } from "@/lib/stores/reset-all";

export const Route = createFileRoute("/reset")({
  beforeLoad: resetAllStorage,
  component: () => null,
});
